/* eslint-disable no-nested-ternary */
import React from 'react';
import { TAdditionalService } from '../postjob/rolecard/agentview/AgentDelegateCard';
import { TBooking } from '../../types';


type TStatusCellProps = {
    additionalServices: TAdditionalService[];
    booking: TBooking;
    jobStatus: string;
    delegated: boolean;
}

export default function StatusCell({
    additionalServices,
    booking,
    jobStatus,
    delegated,
}: TStatusCellProps) {
    let status = jobStatus;

    if (booking && additionalServices && status === 'CL') {
        const job = additionalServices.find(childJob =>
            childJob.bookings.find(childBooking =>
                childBooking.id === booking.id
            )
        );
        if (job) {
            status = job.status;
        }
    }

    const description =
        delegated ?
            'Delegated'
            : !booking && status === 'PA'
            ? 'Cancelled'
            : booking && booking.status === 'CA'
            ? 'Cancelled'
            : booking && booking.status === 'FC'
            ? 'Cancelled'
            : booking && booking.status === 'NS'
            ? 'No Show'
            : status === 'OP'
            ? 'Open'
            : status === 'CF'
            ? 'Confirmed'
            : status === 'CP'
            ? 'Completed'
            : status === 'PA'
            ? 'Paid'
            : status === 'MP'
            ? 'Paid'
            : status === 'IC'
            ? 'In checkout'
            : status === 'OB'
            ? 'Open for backups'
            : status === 'CA'
            ? 'Cancelled'
            : status === 'OE'
            ? 'Open in Emergency'
            : '';

    const statusClass =
        delegated
            ? 'DE'
            : !booking && status === 'PA'
            ? 'CA'
            : booking && ['CA', 'FC', 'NS'].includes(booking.status)
            ? booking.status
            : status || 'all';

    return (
        <div
            className={`rt-status-cell bullet bullet-left bullet-status-${statusClass}`}
        >
            {description}
        </div>
    );
}
